module.exports = __webpack_public_path__ + "img/amanda_front_of_group.9c31e7ab.jpg";